export function getDetailsUrl(title) {
    switch (title?.toLowerCase()) {
        case 'cloud':
            return 'scan/cloud/report/details';
        case 'secrets':
            return 'scan/repository/secret/report/details';
        case 'repository':
            return 'scan/repository/report/details';
        case 'kubernetes':
            return 'scan/infrastructure/report/details';
        case 'application':
            return 'scan/application/report/details';
        case 'pentesting team':
            return 'scan/red-team/report/details';
        case 'image':
            return 'scan/image/report/details';
        case 'iac':
            return 'scan/iac/report/details';
        case 'dependency issues':
            return 'scan/dependency/report/details';
        case 'network':
            return 'scan/domain/report/details';
        case 'artifact':
            return 'scan/artifact/report/details';
        case 'cloud guard':
            return 'scan/cloud-guard/report/details';
        case 'dependency license':
        case 'dependency licenses':
            return 'scan/dependency/licenses/details';
        default:
            return '';
    }
}
